import type {PartialOptions} from "../../../stem-core/ui/UIBase";
import {UI} from "../../../stem-core/ui/UIBase.js";
import {registerStyle, styleRule, StyleSheet} from "../../../stem-core/ui/Style.js";

import {Messages} from "../../Messages.js";
import {PopupMenu} from "../../ui/PopupMenu.jsx";
import {Subscription} from "../../../client/state/SubscriptionStore.js";
import {Donation} from "../../../client/state/DonationStore.js";
import {apiSetPrimaryPaymentMethod} from "../../../client/state/PaymentMethodStore.js";
import {Toast} from "../../ui/Toast.jsx";
import {unwrapArray} from "../../../stem-core/base/Utils.js";
import {PaymentMethodDescription} from "../PaymentMethodDescription.jsx";
import type {PaymentMethod} from "../../../client/state/PaymentMethodStore";


class PaymentMethodInlineMenuStyle extends StyleSheet {
    @styleRule
    container = {
        position: "relative",
        padding: "10px 0",
        fontSize: 15,
        display: "flex",
        alignItems: "center",
        color: this.themeProps.MERCHANT_4,
    };

    @styleRule
    cardDetails = {
        marginRight: 6,
    };
}


// TODO @flow this should be moved into core
interface PaymentMethodInlineMenuOptions {
    handleDelete?: any;
    paymentMethod?: PaymentMethod;
}

@registerStyle(PaymentMethodInlineMenuStyle)
export class PaymentMethodInlineMenu extends UI.Element<PaymentMethodInlineMenuOptions> {
    getDefaultOptions(): PartialOptions<PaymentMethodInlineMenu> {
        return {
            paymentMethod: null,
            handleDelete: null,
        };
    }

    removeAction() {
        const {paymentMethod, handleDelete} = this.options;
        const entries = [
            ...Donation.getActiveRecurring().filter(donation => !donation.isCanceled()),
            ...Subscription.getActiveAndNotCanceled()
        ].filter(recurringPayment => recurringPayment.getPaymentMethod() === paymentMethod);

        if (entries.length) {
            // If there's an active recurring payment using this
            Toast.showError(Messages.paymentMethodInUseError);
        } else {
            handleDelete(paymentMethod);
        }
    }

    async makeDefault() {
        const {paymentMethod} = this.options;
        await apiSetPrimaryPaymentMethod(paymentMethod.id);
        Toast.show(Messages.changesSaved);
    }

    getMenuItems() {
        const {paymentMethod} = this.options;

        return unwrapArray([{
                content: Messages.removeCard,
                onClick: () => this.removeAction(),
            },
            !paymentMethod.isPrimary && {
                content: Messages.makeDefault,
                onClick: () => this.makeDefault(),
            }]);
    }

    render() {
        const {paymentMethod} = this.options;

        return [
            <PaymentMethodDescription
                paymentMethod={paymentMethod}
                showIfDefault
                showExpiryDate
            />,
            <PopupMenu items={this.getMenuItems()}/>
        ];
    }
}
